import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import React, { Component, Fragment } from 'react';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataLotCommercial } from '../../data/DataLotCommercial';
import { DataLotType } from '../../data/DataLotType';
import { DataNature } from '../../data/DataNature';
import { DataOperation } from '../../data/DataOperation';
import { Immocom } from '../../specifique/immocom';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

var excel = {
    arrayitemTableau: [],
    arrayLotType: [],
    arrayNature: [],
    arrayEtage: [],
    arrayExposition: [],

    init: function () {
        var itemNumeroLotCommercial = new this.itemTableau('numeroLotCommercial', 'string');
        var itemNumeroLot = new this.itemTableau('numeroLot', 'string');
        var itemNature = new this.itemTableau('nature', 'typeNature');
        var itemLotType = new this.itemTableau('lotType', 'typeLotType');
        var itemNumCoPro = new this.itemTableau('numCoPro', 'string');
        var itemNombreTantiemes = new this.itemTableau('nombreTantiemes', 'integer');
        var itemBaseTantiemes = new this.itemTableau('baseTantiemes', 'integer');
        var itemEtage = new this.itemTableau('etage', 'typeEtage');
        var itemSurfaceHabitable = new this.itemTableau('surfaceHabitable', 'decimal');
        var itemExposition = new this.itemTableau('exposition', 'typeExposition');
        var itemBatiment = new this.itemTableau('batiment', 'string');
        var itemPrixTTCLot = new this.itemTableau('prixTTCLot', 'decimal');
        var itemPrixMobilierHT = new this.itemTableau('prixMobilierHT', 'decimal');
        var itemLoyerAnnuelHT = new this.itemTableau('loyerAnnuelHT', 'decimal');
        var itemNombreSalleDeBain = new this.itemTableau('nombreSalleDeBain', 'integer');
        var itemNombreWC = new this.itemTableau('nombreWC', 'integer');

        this.arrayitemTableau[0] = itemNumeroLotCommercial;
        this.arrayitemTableau[1] = itemNumeroLot;
        this.arrayitemTableau[2] = itemNature;
        this.arrayitemTableau[3] = itemLotType;
        this.arrayitemTableau[4] = itemNumCoPro;
        this.arrayitemTableau[5] = itemNombreTantiemes;
        this.arrayitemTableau[6] = itemBaseTantiemes;
        this.arrayitemTableau[7] = itemEtage;
        this.arrayitemTableau[8] = itemSurfaceHabitable;
        this.arrayitemTableau[9] = itemExposition;
        this.arrayitemTableau[10] = itemBatiment;
        this.arrayitemTableau[11] = itemPrixTTCLot;
        this.arrayitemTableau[12] = itemPrixMobilierHT;
        this.arrayitemTableau[13] = itemLoyerAnnuelHT;
        this.arrayitemTableau[14] = itemNombreSalleDeBain;
        this.arrayitemTableau[15] = itemNombreWC;

        this.arrayEtage.push("");
        this.arrayEtage.push("R-1");
        this.arrayEtage.push("R-2");
        this.arrayEtage.push("R-3");
        this.arrayEtage.push("R-4");
        this.arrayEtage.push("R-5");

        this.arrayEtage.push("RDC");
        this.arrayEtage.push("RDJ");
        this.arrayEtage.push("R+1");
        this.arrayEtage.push("R+2");
        this.arrayEtage.push("R+3");
        this.arrayEtage.push("R+4");
        this.arrayEtage.push("R+5");
        this.arrayEtage.push("R+6");
        this.arrayEtage.push("R+7");
        this.arrayEtage.push("R+8");
        this.arrayEtage.push("R+9");
        this.arrayEtage.push("R+10");
        this.arrayEtage.push("R+11");
        this.arrayEtage.push("R+12");
        this.arrayEtage.push("R+13");
        this.arrayEtage.push("R+14");
        this.arrayEtage.push("R+15");
        this.arrayEtage.push("R+16");
        this.arrayEtage.push("R+17");
        this.arrayEtage.push("R+18");

        this.arrayExposition.push("");
        this.arrayExposition.push("E");
        this.arrayExposition.push("EO");
        this.arrayExposition.push("ESO");
        this.arrayExposition.push("N");
        this.arrayExposition.push("NE");
        this.arrayExposition.push("NES");
        this.arrayExposition.push("NO");
        this.arrayExposition.push("O");
        this.arrayExposition.push("ONE");
        this.arrayExposition.push("S");
        this.arrayExposition.push("SE");
        this.arrayExposition.push("SN");
        this.arrayExposition.push("SO");
        this.arrayExposition.push("SON");
    },
    itemTableau: function (Nom, Type) {
        this.nom = Nom;
        this.type = Type;
    }
}

export class DetailsListImportExport extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListImportExportWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListImportExportWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    static defaultState = {
        items: [],
        onActiveBoutonEnregistrer: false,
        peutModifierOperation: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...DetailsListImportExportWithPerimetre.defaultState };
        this._columns = this._getColumns();
        this._navigateur = Immocom.getNavigateur();
        excel.init();
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement en cours'
        });

        DataOperation._chargementImportExport().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const items = objetData[0] || [];
                const peutModifierOperation = objetData[1] || false;

                let callback = undefined;
                if (items.length === 0)
                    callback = () => this.setState({ warningMessage: "Aucune donnée pour cette opération" });

                const state = { items, peutModifierOperation };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, callback);
            }
            else {
                const state = { items: [] };
                Immocom.onTraitementErreurAvecState(this, state, retourVerif, responseFetch);
            }
        });

    };

    _chargementLotType = () => {
        DataLotType._chargementLotTypes({}).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet || [];
                objetData.forEach(value => excel.arrayLotType.push(value.lotType));
            }
            else excel.arrayLotType = [];
        });
    };

    _chargementNature = () => {
        DataNature._chargementNature(0, "").then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet || [];
                objetData.forEach(value => excel.arrayNature.push(value.nature));
            }
            else excel.arrayNature = [];
        });
    };

    _getColumns = () => {

        const renderCell = (item, cellType) => {
            const valeur = item[cellType];
            const estValeurValide = item[`ok_${cellType}`];
            if (estValeurValide !== undefined && !estValeurValide)
                return <div style={{
                    backgroundColor: "#dc3545",
                    color: "white",
                    height: "100%",
                    padding: "0 5px",
                }}>
                    <span title={valeur}>{valeur}</span>
                </div>
            else return <span title={valeur}>{valeur}</span>
        };

        return [{
            ariaLabel: 'N° lot commercial',
            isResizable: true,
            key: 'numeroLotCommercial',
            minWidth: 45,
            maxWidth: 90,
            name: 'N° lot commercial',
            onRender: item => renderCell(item, "numeroLotCommercial")
        }, {
            ariaLabel: 'N° lot',
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'numeroLot',
            minWidth: 100,
            maxWidth: 150,
            name: 'N° lot',
            onRender: item => renderCell(item, "numeroLot")
        }, {
            ariaLabel: 'Nature',
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'nature',
            minWidth: 100,
            maxWidth: 150,
            name: 'Nature',
            onRender: item => renderCell(item, "nature")
        }, {
            ariaLabel: 'Type de lot',
            isResizable: true,
            key: 'lotType',
            minWidth: 100,
            maxWidth: 150,
            name: 'Type de lot',
            onRender: item => renderCell(item, "lotType")
        }, {
            ariaLabel: 'Num Copro',
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            isResizable: true,
            key: 'numCoPro',
            minWidth: 45,
            maxWidth: 90,
            name: 'Num Copro',
            onRender: item => renderCell(item, "numCoPro")
        }, {
            ariaLabel: 'Nombre tantièmes',
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            isResizable: true,
            key: 'nombreTantiemes',
            minWidth: 45,
            maxWidth: 90,
            name: 'Nombre tantièmes',
            onRender: item => renderCell(item, "nombreTantiemes")
        }, {
            ariaLabel: 'Base tantièmes',
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            isResizable: true,
            key: 'baseTantiemes',
            minWidth: 45,
            maxWidth: 90,
            name: 'Base tantièmes',
            onRender: item => renderCell(item, "baseTantiemes")
        }, {
            ariaLabel: 'Etage',
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'etage',
            minWidth: 45,
            maxWidth: 90,
            name: 'Etage',
            onRender: item => renderCell(item, "etage")
        }, {
            ariaLabel: 'Surface habitable',
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'surfaceHabitable',
            minWidth: 45,
            maxWidth: 90,
            name: 'Surface habitable',
            onRender: item => renderCell(item, "surfaceHabitable")
        }, {
            ariaLabel: 'Exposition',
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'exposition',
            minWidth: 45,
            maxWidth: 90,
            name: 'Exposition',
            onRender: item => renderCell(item, "exposition")
        }, {
            ariaLabel: 'Batiment',
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'batiment',
            minWidth: 45,
            maxWidth: 90,
            name: 'Batiment',
            onRender: item => renderCell(item, "batiment")
        }, {
            ariaLabel: 'Prix TTC lot',
            isResizable: true,
            key: 'prixTTCLot',
            minWidth: 100,
            maxWidth: 150,
            name: 'Prix TTC lot',
            onRender: item => renderCell(item, "prixTTCLot")
        }, {
            ariaLabel: 'Prix mobilier HT',
            isResizable: true,
            key: 'prixMobilierHT',
            minWidth: 100,
            maxWidth: 150,
            name: 'Prix mobilier HT',
            onRender: item => renderCell(item, "prixMobilierHT")
        }, {
            ariaLabel: 'Loyer annuel HT',
            isResizable: true,
            key: 'loyerAnnuelHT',
            minWidth: 100,
            maxWidth: 150,
            name: 'Loyer annuel HT',
            onRender: item => renderCell(item, "loyerAnnuelHT")
        }, {
            ariaLabel: 'Nombre salle de bain',
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            isResizable: true,
            key: 'nombreSalleDeBain',
            minWidth: 45,
            maxWidth: 90,
            name: 'Nb sdb',
            onRender: item => renderCell(item, "nombreSalleDeBain")
        }, {
            ariaLabel: 'Nombre WC',
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            isResizable: true,
            key: 'nombreWC',
            minWidth: 45,
            maxWidth: 90,
            name: 'Nb WC',
            onRender: item => renderCell(item, "nombreWC")
        }];
    };

    _getItems = () => {
        const { onActiveBoutonEnregistrer, peutModifierOperation } = this.state;
        if (!peutModifierOperation) return [];
        else return [{
            iconProps: { iconName: 'Copy' },
            key: 'copier',
            name: 'Copier',
            onClick: this._copy
        }, {
            iconProps: { iconName: 'Paste' },
            key: 'coller',
            name: 'Coller',
            onClick: this._paste
        }, {
            iconProps: { iconName: 'Refresh' },
            key: 'reinitialiser',
            name: 'Réinitialiser',
            onClick: this._onReinitialiser
        }, {
            disabled: !onActiveBoutonEnregistrer,
            iconProps: { iconName: 'Save' },
            key: 'enregistrer',
            name: 'Enregistrer',
            onClick: this._onEnregistrement
        }]
    };

    _getFarItems = () => {
        return [{
            key: 'nombreEnregistrement',
            name: (this.state.items != null ? this.state.items.length : 0)
        }];
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced>
            {defaultRender(props)}
        </Sticky>;
    };

    _copy = () => {

        const onError = error => {
            alert("Une erreur est survenue");
            console.log(error);
        };

        const copy = (data) => {
            try {
                navigator.clipboard.writeText(data)
                    .then(() => alert("Dans Excel, clic droit > collage spécial > texte"))
                    .catch(onError);
            }
            catch (e) { onError(e) }
        };

        let data = "";

        if (this._navigateur === "Chrome" || this._navigateur === "Edge" || this._navigateur === "Firefox") {

            // Chargement des tableaux de paramètres dans le clipboard
            data += "LotType : \t";
            excel.arrayLotType.forEach(lotType => data += lotType + "\t");
            data += "\r\n";

            data += "Nature : \t";
            excel.arrayNature.forEach(nature => data += nature + "\t");
            data += "\r\n";

            data += "Etage : \t";
            excel.arrayEtage.forEach(etage => data += etage + "\t");
            data += "\r\n";

            data += "Exposition : \t";
            excel.arrayExposition.forEach(exposition => data += exposition + "\t");

            // Séparation
            for (let i = 1; i <= 6; i++)
                data += "\r\n";

            // Entête
            data += "numeroLotCommercial\t";
            data += "numeroLot\t";
            data += "nature\t";
            data += "lotType\t";
            data += "numCoPro\t";
            data += "nombreTantiemes\t";
            data += "baseTantiemes\t";
            data += "etage\t";
            data += "surfaceHabitable\t";
            data += "exposition\t";
            data += "batiment\t";
            data += "prixTTCLot\t";
            data += "prixMobilierHT\t";
            data += "loyerAnnuelHT\t";
            data += "nombreSalleDeBain\t";
            data += "nombreWC\t";

            data += "\r\n";

            this.state.items.forEach(item => {
                Object.keys(item).forEach(key => {
                    if (key !== "idOperation" && key !== "idLotCommercial" && key !== "idLot" && key !== "prixHTLot" && key !== "prixHTLotCommercial") {
                        const value = item[key] !== null ? item[key].toString() : "";
                        data += value + "\t";
                    }
                });
                data += "\r\n";
            });

            // Source : http://help.dottoro.com/ljctuhrg.php
            if (window.clipboardData) { // Internet Explorer
                window.clipboardData.setData("Text", data);
            }
            else { // Autres navigateurs
                if (this._navigateur === "Firefox") {
                    alert("Attention : sur Firefox cette fonctionnalité peut ne pas fonctionner correctement, si tel est le cas veuillez utiliser Microsoft Edge ou Google Chrome");
                    copy(data);
                }
                else navigator.permissions.query({ name: "clipboard-write" })
                    .then(result => {
                        if (result.state === "granted" || result.state === "prompt")
                            copy(data);
                        else alert("Cette fonctionnalité n'est pas disponible, veuillez accorder les permissions nécessaires à votre navigateur");
                    })
                    .catch(onError);
            }
        }
        else alert("Cette fonctionnalité n'est pas disponible sur ce navigateur : veuillez utiliser Microsoft Edge ou Google Chrome");

    };

    _paste = () => {

        const onError = error => {
            alert("Une erreur est survenue");
            console.log(error);
        };

        const paste = () => {
            try {
                navigator.clipboard.readText()
                    .then(data => this._extractData(data))
                    .catch(onError);
            }
            catch (e) { onError(e) }
        };

        if (this._navigateur === "Chrome" || this._navigateur === "Edge" || this._navigateur === "Firefox") {
            // Source : http://help.dottoro.com/ljctuhrg.php
            if (window.clipboardData) { // Internet Explorer
                let clipboard = window.clipboardData.getData('Text');
                this._extractData(clipboard);
            }
            else { // Autres navigateurs
                if (this._navigateur === "Firefox") { // Nécessite la modification de la clef dom.events.asyncClipboard.readText à true dans about:config
                    alert("Attention : sur Firefox cette fonctionnalité peut ne pas fonctionner correctement, si tel est le cas veuillez utiliser Microsoft Edge ou Google Chrome");
                    paste();
                }
                else navigator.permissions.query({ name: "clipboard-read" })
                    .then(result => {
                        if (result.state === "granted" || result.state === "prompt")
                            paste();
                        else alert("Cette fonctionnalité n'est pas disponible, veuillez accorder les permissions nécessaires à votre navigateur");
                    })
                    .catch(onError);
            }
        }
        else alert("Cette fonctionnalité n'est pas disponible sur ce navigateur : veuillez utiliser Microsoft Edge ou Google Chrome");

    };

    _extractData = (data) => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursDeTraitement: 'Chargement en cours'
        });

        const expectedLength = excel.arrayitemTableau.length;
        let onPeutEnregistrer = true;
        let rows = data.split("\r\n");
        if (this._navigateur === "Firefox") rows = data.split("\n"); // KP - 19/06/2023 : compatibilité Firefox
        let items = [];

        // Pour chacune des lignes dans le presse papier...
        rows.forEach(row => {

            const cells = row.split("\t");
            let item = {};
            let itemNature = "";

            if (cells.length === expectedLength) {

                // Pour chacune des cellules de la ligne en cours de traitement...
                for (var i = 0; i < expectedLength; i++) {
                    const nom = excel.arrayitemTableau[i].nom;
                    const type = excel.arrayitemTableau[i].type;

                    if (cells[i].indexOf(nom) === 0); // Ignorer les entêtes
                    else {

                        let cellValue = cells[i].trim();
                        let estValide = false;

                        if (type === "typeLotType") {
                            estValide = excel.arrayLotType.includes(cellValue);
                        }
                        else if (type === "typeNature") {
                            var index = excel.arrayNature.indexOf(cellValue);
                            estValide = index >= 0;
                            if (estValide) itemNature = excel.arrayNature[index];
                            console.log("index = " + index)
                            console.log("cellValue = " + cellValue)
                            console.log("itemNature = " + itemNature)
                        }
                        else if (type === "typeEtage") {
                            estValide = excel.arrayEtage.includes(cellValue);
                            // Etage obligatoire pour les Appartements
                            if (itemNature === "Appartement")
                                estValide &= !!cellValue;
                        }
                        else if (type === "typeExposition") {
                            estValide = excel.arrayExposition.includes(cellValue);
                            // Exposition obligatoire pour les Appartements
                            if (itemNature === "Appartement")
                                estValide &= !!cellValue;
                        }
                        else if (type === "decimal") {

                            const estDecimal = cellValue.match(/^[0-9]+([\,\.][0-9]{0,3})?$/) !== null;

                            // Par défaut champ valide si décimal ou si non renseigné
                            estValide = estDecimal || cellValue === "";

                            // SHA obligatoire pour les Appartements, Balcon, Cave, Jardin, Loggia, Terrasse, Terrain
                            if (nom === "surfaceHabitable" && (itemNature === "Appartement" || itemNature === "Balcon" || itemNature === "Cave" || itemNature === "Jardin" || itemNature === "Loggia" || itemNature === "Terrasse" || itemNature === "Terrain"))
                                estValide = estDecimal && cellValue !== "";

                            // Prix TTC obligatoire pour tous
                            else if (nom === "prixTTCLot") {
                                estValide = estDecimal && cellValue !== "";
                                // Prix TTC > 0 pour les parkings et caves
                                if (itemNature === "Cave" || itemNature === "Parking")
                                    estValide &= cellValue !== "0";
                            }
                        }
                        else if (type === "integer") {

                            const estInteger = cellValue.match(/^\d{0,10}?$/) !== null;

                            // Par défaut champ valide si integer ou si non renseigné
                            estValide = estInteger || cellValue === "";

                            // Champs nombreSalleDeBain et nombreWC uniquement pour lots de type Appartement ou Maison
                            if (nom === "nombreSalleDeBain" || nom === "nombreWC") {
                                if (itemNature === "Appartement" || itemNature === "Maison individuelle" || itemNature === "Maison individuelle constructeur")
                                    estValide = estInteger && cellValue !== "";
                                else estValide = cellValue === "";
                            }
                        }
                        else if (type === "string") {
                            estValide = true;
                        }

                        onPeutEnregistrer &= estValide;

                        item[nom] = cellValue;
                        item["ok_" + nom] = estValide;
                    }
                }
            }

            // Si l'objet n'est pas vide
            if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
                items.push(item);
            }
        });

        let state = {
            items,
            onActiveBoutonEnregistrer: true,
            enCoursDeTraitement: false,
            messageEnCoursDeTraitement: '',
            warningMessage: '',
            errorMessage: ''
        };
        if (!onPeutEnregistrer) {
            state.onActiveBoutonEnregistrer = false;
            state.errorMessage = "Impossible de coller les données. Vérifiez les lignes surlignées en rouge."
        }
        this.setState(state);

    };

    _onReinitialiser = () => {
        this._chargementDonnees();
    };

    _onEnregistrement = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement en cours'
        });

        DataLotCommercial._importLotsCommerciaux(this.state.items).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {});
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    componentDidMount = () => {
        this._chargementDonnees();
        this._chargementLotType();
        this._chargementNature();
    };

    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this._chargementDonnees();
    //    }
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this._chargementDonnees();
    };

    render = () => {

        const { items } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                    farItems={this._getFarItems()}
                    ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        <DetailsList
                            columns={this._columns}
                            items={items}
                            onRenderDetailsHeader={this._onRenderDetailsHeader}
                            selectionMode={SelectionMode.none}
                        />
                    </ScrollablePane>
                </div>
            </Stack>

        </Fragment>;

    };

};